// A concept with a city pin but no venue or duration still needs its logistics
// chosen when it is activated as an event.
export const isConceptAwaitingDetails = (event) => {
  if (String(event?.type || "").toLowerCase() !== "concept") return false;
  if (typeof event?.awaiting_concept_details === "boolean") {
    return event.awaiting_concept_details;
  }
  return Number(event?.event_format) !== 0 &&
    !String(event?.venue_name || "").trim() &&
    !String(event?.street || "").trim() &&
    !String(event?.building_number || "").trim() &&
    !Number(event?.approximate_duration);
};
